<template>
  <!--
    DemoSwitcher — perfil demo actual + abre el selector para cambiar de perfil
    o salir de la demo. Solo con sesión de demo y en rutas de la app.
      · `inline`: dentro del nav del header (desktop, Header.vue).
      · sin `inline`: píldora flotante abajo (solo < 992px, donde no hay nav;
        la monta App.vue). El corte lo decide el CSS, no el componente.
  -->
  <div v-if="visible" :class="['demo-sw', { 'demo-sw--inline': inline }]">
    <button type="button" class="demo-sw__btn" :aria-label="$t('demoAccess.switch')" @click="open = true">
      <span class="demo-sw__dot" aria-hidden="true" />
      <span class="demo-sw__tag">{{ $t('demoAccess.badge') }}</span>
      <span class="demo-sw__label">{{ label }}</span>
      <PhCaretUpDown :size="16" />
    </button>
    <DemoAccessModal v-model="open" />
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { PhCaretUpDown } from '@phosphor-icons/vue';
import DemoAccessModal from '@/components/demo/DemoAccessModal.vue';
import { useDemoAccess, hasDemoSession } from '@/composables/useDemoAccess';
import { useLocalStorage } from '@/composables/useLocalStorage';

export default {
  name: 'DemoSwitcher',
  components: { DemoAccessModal, PhCaretUpDown },
  props: {
    inline: { type: Boolean, default: false },
  },
  setup() {
    const { locale } = useI18n();
    const route = useRoute();
    const { persona } = useDemoAccess();
    const { getLocalAccessToken } = useLocalStorage();
    const open = ref(false);

    const visible = computed(() => {
      // Depende de la ruta para reevaluar al navegar (la sesión vive en storage).
      const inApp = route.matched.some((r) => r.meta?.authorize !== undefined);
      return inApp && hasDemoSession() && !!persona.value && !!getLocalAccessToken();
    });
    const label = computed(() => {
      const l = persona.value?.label;
      if (!l) return '';
      const lang = String(locale.value || 'es').slice(0, 2);
      return typeof l === 'string' ? l : (l[lang] || l.es || l.en || '');
    });

    return { open, visible, label };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/components/demo/demo-switcher";
</style>
